import { createTheme } from '@material-ui/core/styles';
import palette from './palette';
import typography from './typography';
import border from './border';
import overrides from './overrides';

export const lightTheme = {
    palette,
    typography,
    border,
    overrides,
};

export const getTheme = (defaultTheme = lightTheme, theme) => createTheme({
    ...defaultTheme,
    ...theme,
});
